<template>
  <div :class="['upsell-block', flow, state, !isFreeSsl || 'isFreeSsl', hasSsl217 || 'sslDomainV3']">
    <div class="block">
      <div class="unit">
        <v-expansion-panels v-model="upsell">
          <v-expansion-panel>
            <v-expansion-panel-header data-attr="upsell-activator" expand-icon="sr-icon-arrow-down">
              <h3 v-if="isVisibleTitle" class="header">
                <span v-if="isFreeSsl" class="free-promo highlight">{{ $t('popupSsl.promo') }}</span>
                <span v-html="getHeaderText()"></span>
              </h3>

              <p v-if="isVisibleInfo">{{ $t(`upsell.${flow}.info`) }}</p>

              <v-expand-transition>
                <div class="head" v-if="isVisibleHead">
                  <div class="group" v-if="flow !== UPSELL_FLOW.DOMAIN_SSL">

                    <img
                      v-if="isVisibleHeadImg"
                      :src="require(`@/assets/images/${selectedUpsell?.brand || upsellData?.ssl[0].brand}-black.svg`)"
                      :alt="selectedUpsell?.brand|| upsellData?.ssl[0].brand"
                    >

                    <div class="heading">
                      <v-icon :class="flow === UPSELL_FLOW.HOSTING_DOMAIN || flow === UPSELL_FLOW.HOSTING_SSL ? 'sr-icon-gift' : 'sr-icon-lock-check'"/>
                      <span class="title">{{ selectedUpsell?.title || upsellData?.ssl[0].title }}</span>
                      <span>{{ selectedUpsell?.name || upsellData?.ssl[0].name }}</span>
                      <v-tooltip right max-width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                              tag="span"
                              fab
                              @click.stop="$event.preventDefault()"
                              class="tooltip"
                          >
                            <v-icon class="sr-icon-help"/>
                          </v-btn>
                        </template>
                        <h4>{{ $t(`popupSsl.details.title`) }}</h4>
                        <span v-for="(ssl, key) in getFilteredDetails(selectedUpsell?.fields || upsellData?.ssl[0].fields)" :key="key">
                            <span class="detail-name"> {{ $t(`popupSsl.details.${key}.title`) }}</span>
                            <b v-html="getSslContent(key, ssl) || '&#8212;'"></b>
                          </span>
                      </v-tooltip>
                    </div>

                    <div class="cost">
                      <span class="new" v-html="priceTransform(paymentPeriod.price, currencyInfo.suffix, '', currencyInfo.prefix)"></span>
                      <span class="period" v-html="' / ' + $t('periods.' + paymentPeriod.period)"></span>
                    </div>
                  </div>

                </div>

              </v-expand-transition>
              <div class="added" v-if="isVisibleAdded">
                <v-icon class="sr-icon-check"/>
                {{ $t('upsell.addedToOrder') }}
              </div>
              <v-switch
                  v-if="isVisibleAdd"
                  v-model="selectedUpsell"
                  inset
                  :label="$t('upsell.addForFree')"
                  @click.stop="$event.preventDefault()"
                  class="switcher"
              >
              </v-switch>

            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p class="ssl-hosting-gift" v-if="isVisibleSslGift"><span class="free-promo highlight">{{ $t('popupSsl.promo') }}</span>{{ $t(`upsell.${flow}.gift`) }}</p>
              <div
                  v-if="upsellData?.ssl"
                  :class="['ssl-block', { 'multiple': upsellData?.ssl.length > 1 }]"
              >
                <div
                    v-for="(item, key) in upsellData?.ssl"
                    :key="key"
                    class="item"
                    :class="{ 'is-active': selectedUpsell?.pid === item.pid }"
                >
                  <div class="head">
                    <img
                        v-if="isVisibleHeadImg"
                        :src="require(`@/assets/images/${item.brand}-black.svg`)"
                        :alt="item.brand"
                    >
                    <div class="heading">
                      <v-icon :class="flow === UPSELL_FLOW.HOSTING_DOMAIN || flow === UPSELL_FLOW.HOSTING_SSL ? 'sr-icon-gift' : 'sr-icon-lock-check'"/>
                      <span v-if="item.title" class="title">{{item.title}}</span>
                      <span style="white-space: nowrap;">{{item.name}}<v-tooltip right max-width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                              tag="span"
                              fab
                              @click.stop="$event.preventDefault()"
                          >
                            <v-icon class="sr-icon-help"/>
                          </v-btn>
                        </template>
                          <h4>{{ $t(`popupSsl.details.title`) }}</h4>
                          <span v-for="(ssl, key) in getFilteredDetails(item.fields)" :key="key">
                            <span class="detail-name"> {{ $t(`popupSsl.details.${key}.title`) }}</span>
                            <b v-html="getSslContent(key, ssl) || '&#8212;'"></b>
                          </span>
                    </v-tooltip>
                      </span>
                    </div>

                    <div class="line"><span class="highlight" v-if="hasSsl217">{{ $t('upsell.popularCertificate') }}</span></div>
                  </div>

                  <p v-html="item.description[currencyInfo.lang.toLowerCase()]" />

                  <div class="details" v-if="item.details">

                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>{{ $t('actions.details') }}</v-expansion-panel-header>
                        <v-expansion-panel-content>{{ item.details }}</v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>

                  <div class="bottom">
                    <div class="cost">
                      <span class="old" v-html="numberTransform(getCycleData(item, 'price', true))" v-if="isFreeSsl"></span>
                      <span class="new" v-html="priceTransform(numberTransform(getCycleData(item, 'price')), currencyInfo.suffix, '', currencyInfo.prefix)"/>
                      <span
                          class="period"
                          v-html="' / ' + (isFreeSslPeriod ? $t('upsell.hostingActive') : $t('periods.' + getCycleData(item, 'period')))"
                      />
                    </div>

                    <v-switch
                        v-model="selectedUpsell"
                        :value="item"
                        inset
                        :label="selectedUpsell?.pid === item.pid ? $t(`upsell.addedToOrder`) : isFreeSsl ? $t(`upsell.addForFree`) : ''"
                        class="switcher"
                    >
                    </v-switch>
                  </div>
                </div>
              </div>

              <v-expand-transition>
                <div v-if="isVisibleSslHostingGift" class="auto-install-ssl">
                  <v-checkbox
                      v-model="autoInstallSsl"
                      :label="$t('upsell.autoInstallSsl')"
                      :ripple="false"
                      color="primary"
                  />
                  <v-expand-transition>
                    <p
                        v-if="autoInstallSsl"
                        v-html="$t('upsell.autoInstallSslHint', { domain: domainName, faqHostingDnsLink: $options.URLS.FAQ_HOSTING_DNS[this.lang], faqHostingDnsAttr: 'auto-install-ssl'})"
                    ></p>
                  </v-expand-transition>
                </div>
              </v-expand-transition>

              <div
                  :class="[ 'certificates', isBasicCertificates]"
                  v-if="isVisibleCertificates"
              >
                <b v-html="$t(`upsell.certificatesIntro`)"></b>
                <div class="button" @click="openPopup">
                  <i class="sr-icon-info"/><span class="link">{{ isSsl ? $t(`upsell.viewAllCertificates`) : 'Дивитись тарифи хостингу' }} </span>
                  <v-progress-circular :size="20" width="2" color="primary" indeterminate v-if="loadingAllSsl" class="ml-3" top/>
                </div>

                <ssl-hosting-popup
                    :show-popup.sync="showPopup"
                    :state.sync="state"
                    :currency-info="currencyInfo"
                    :is-ssl="isSsl"
                    :ssl-items="allSsl"
                    @update:upsellData="updateUpsellData"
                    :startChat="startChat"
                >
                </ssl-hosting-popup>
              </div>

              <payment-periods
                  v-show="isVisiblePaymentPeriod"
                  @paymentPeriod="(!isVisiblePaymentPeriod && isVisibleDomainName) || getPaymentPeriod($event)"
                  :currency-info="currencyInfo"
                  :payment-periods="filteredPaymentPeriods"
                  :selected-payment-period="savedPaymentPeriod"
                  :upsell="true"
                  data-attr="ssl-payment-periods"
                  :class="['ssl-payment-periods', isVisiblePaymentPeriod || 'hide-mb']"
                  :domain-type="selectedUpsell?.product?.type"
              />

              <extra-options
                  v-if="isVisiblePaymentPeriod && flow === UPSELL_FLOW.HOSTING_DOMAIN"
                  :currency-info="currencyInfo"
                  :config-opt="configOptions"
                  :payment-period="paymentPeriod"
                  domain-type=""
                  data-attr="ssl-extra-options"
                  class="extra-options"
              />

              <domain-name
                  v-if="isVisibleDomainName"
                  ref="domainName"
                  @domainName="getDomainName($event)"
                  :currency-info="currencyInfo"
                  initial-domain-opt=""
                  :free-domain-info="freeDomainInfo"
                  :payment-period="paymentPeriod"
                  domain-type="shared"
                  flow="default"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {CART_GETTERS, CART_ACTIONS, CART_MUTATIONS} from "@/store/modules/cart-context";
import {SETTINGS_GETTERS} from "@/store/modules/settings";
import { priceTransform } from '@/modules/priceTransform';
import {nameTranslate} from "@/modules/nameTranslate";
import {numberTransform} from "@/modules/numberTransform";
import {SSL_POPUP, UPSELL_FLOW, FLOW, URLS} from "@/constants";
import { getAllUpsaleSsl } from "@/store/api/settings";
import * as Sentry from "@sentry/vue";
import PaymentPeriods from "../PaymentPeriods.vue";
import ExtraOptions from "../ExtraOptions.vue";
import DomainName from "../DomainName.vue";
import SslHostingPopup from "./SslHostingPopup.vue";

export default {
    name: "Upsell",
    URLS,
    components: {
      PaymentPeriods,
      ExtraOptions,
      DomainName,
      SslHostingPopup
    },
    props: {
      flow: { type: String, Boolean },
      pageFlow: { type: String, Boolean },
      currencyInfo: { type: [Object, Array], default: () => ({}) },
      initUpsellData: { type: [Object, Array], default: () => ([]) },
      startChat: { type: Function, required: true },
      isFreeSslPeriod: { type: Boolean, default: false },
    },
    data: () => ({
      state: '',
      upsell: 0,
      selectedUpsell: false,
      items: [],
      details: undefined,
      UPSELL_FLOW,
      configOptions: [],
      paymentPeriod: { period: 'annually'},
      freeDomainInfo: {},
      summaryList: [],
      showPopup: false,
      allSsl: [],
      savedAllSsl: [],
      loading: false,
      loadingAllSsl: false,
      upsellData: [],
      savedPaymentPeriod: null,
      isFreeSsl: false,
      freePid: "481",
      filteredPaymentPeriods: [],
      autoInstallSsl: false,

      hideSslHostingGift: true,
    }),
    mounted() {
      this.$nextTick(() => {
        this.getAllSsl();
      });
    },
    computed: {
      ...mapGetters('settings', {
        lang: SETTINGS_GETTERS.LANG,
        currency: SETTINGS_GETTERS.CURRENCY,
        currencySuffix: SETTINGS_GETTERS.CURRENCY_SUFFIX,
      }),
      ...mapGetters('cartContext', {
        cartContext: CART_GETTERS.CART_CONTEXT,
      }),
      isSsl() {
        const { flow } = this;
        const visibleFlows = [
          'SSL_GIFT_HOSTING',
          'SSL_HOSTING',
          'SSL_DOMAIN'
        ].map(key => UPSELL_FLOW[key]);

        return visibleFlows.includes(flow);
      },
      isVisibleTitle() {
        const { flow, upsell, selectedUpsell, domainName } = this;

        const alwaysVisibleFlows = [
          'SSL_GIFT_HOSTING',
          'HOSTING_DOMAIN',
          'HOSTING_SSL'
        ].map(key => UPSELL_FLOW[key]);
        const hideIfUndefinedAndActiveFlows = [
          'SSL_HOSTING',
          'SSL_DOMAIN'
        ].map(key => UPSELL_FLOW[key]);
        const hideDomainSsl = (flow === UPSELL_FLOW.DOMAIN_SSL && upsell === undefined && domainName?.name);

        return alwaysVisibleFlows.includes(flow) || (hideIfUndefinedAndActiveFlows.includes(flow) && !(upsell === undefined && selectedUpsell)) || !hideDomainSsl;
      },
      isVisibleInfo() {
        const { flow, upsell, selectedUpsell, domainName, isFreeSsl } = this;
        const alwaysHiddenFlows = [
          'SSL_GIFT_HOSTING',
          'HOSTING_DOMAIN',
          'HOSTING_SSL'
        ].map(key => UPSELL_FLOW[key]);

        if (flow === UPSELL_FLOW.SSL_HOSTING && isFreeSsl) {
          return false;
        };

        const shouldHide =
          (flow === UPSELL_FLOW.SSL_HOSTING || flow === UPSELL_FLOW.SSL_DOMAIN) && upsell === undefined && selectedUpsell ||
          (flow === UPSELL_FLOW.DOMAIN_SSL && upsell === undefined && domainName?.name);

        return !alwaysHiddenFlows.includes(flow) && !shouldHide;
      },
      isVisibleHead() {
        const { flow, upsell, selectedUpsell, domainName, isFreeSsl } = this;
        const isUpsellUndefined = upsell === undefined;

        const alwaysVisibleHead = [
          'SSL_GIFT_HOSTING',
          'HOSTING_DOMAIN',
          'HOSTING_SSL',
        ].map(key => UPSELL_FLOW[key]);

        const selectedVisibleHead = [
          'SSL_HOSTING',
          'SSL_DOMAIN'
        ].map(key => UPSELL_FLOW[key]);

        if (flow === UPSELL_FLOW.SSL_HOSTING && isFreeSsl && isUpsellUndefined) { return true };

        return (
          isUpsellUndefined && (
            alwaysVisibleHead.includes(flow) ||
            (selectedVisibleHead.includes(flow) && selectedUpsell) ||
            (flow === UPSELL_FLOW.DOMAIN_SSL && domainName?.name)
          )
        );
      },
      isVisibleHeadImg() {
        const { flow } = this;
        const alwaysHiddenFlows = [
          'HOSTING_DOMAIN',
          'HOSTING_SSL',
          'DOMAIN_SSL'
        ].map(key => UPSELL_FLOW[key]);

        return !alwaysHiddenFlows.includes(flow);
      },
      isVisibleAdded() {
        return (this.isFreeSsl && this.upsell) ||
          (this.flow === UPSELL_FLOW.DOMAIN_SSL && this.upsell === undefined && this.domainName?.name) ||
          (this.selectedUpsell && this.upsell === undefined);
      },
      isVisibleAdd() {
        const { flow, upsell, selectedUpsell, isFreeSsl } = this;

        return (isFreeSsl && upsell === undefined && !selectedUpsell)|| (
          (flow === UPSELL_FLOW.SSL_GIFT_HOSTING ||
            flow === UPSELL_FLOW.HOSTING_DOMAIN ||
            flow === UPSELL_FLOW.HOSTING_SSL) &&
          upsell === undefined &&
          !selectedUpsell
        );
      },
      isBasicCertificates() {
        const { flow, isFreeSsl } = this;
        const visibleFlows = [
          'SSL_GIFT_HOSTING',
          'HOSTING_DOMAIN',
          'HOSTING_SSL'
        ].map(key => UPSELL_FLOW[key]);

        if (flow === UPSELL_FLOW.SSL_HOSTING) {
          return isFreeSsl ? '' : 'basic';
        }

        return !visibleFlows.includes(flow) ? 'basic' : '';
      },
      isVisibleCertificates() {
        return this.flow !== UPSELL_FLOW.DOMAIN_SSL;
      },
      isVisiblePaymentPeriod() {
        const popupStates = [
          'SSL_GIFT_HOSTING',
          'HOSTING_DOMAIN',
          'HOSTING_SSL'
        ].map(key => UPSELL_FLOW[key]);

        if(this.flow === UPSELL_FLOW.SSL_HOSTING && this.isFreeSsl) { return false}

        return this.selectedUpsell &&
          (popupStates.includes(this.flow) ? this.state === 'popup-active' : this.flow !== UPSELL_FLOW.DOMAIN_SSL);
      },
      isVisibleDomainName() {
        return (this.flow === UPSELL_FLOW.HOSTING_SSL && (this.state === 'popup-active' || this.selectedUpsell)) || this.flow === UPSELL_FLOW.DOMAIN_SSL;
      },
      isVisibleSslGift() {
        if(this.isFreeSslPeriod === null) { return false }
        return this.flow === UPSELL_FLOW.SSL_HOSTING && !this.isFreeSslPeriod;
      },

      isVisibleSslHostingGift() {
        if (this.hideSslHostingGift) return false;

        let flag = false;
        const isSelectedSsl = this.selectedUpsell && Object.keys(this.selectedUpsell).length;

        if(isSelectedSsl) {
          if(this.pageFlow === FLOW.DOMAIN) {
            flag = Number(this.cartContext?.products?.[0]?.pid) === 542 && this.selectedUpsell.auto_install_ssl_available;
          } else {
            flag = this.isFreeSsl || this.selectedUpsell?.auto_install_ssl_available
          }
        }

        return flag;
      },
      domainName() {
        return this.cartContext.domains[0].domain;
      },
      hasSsl217() {
        return Array.isArray(this.upsellData.ssl) &&
          this.upsellData.ssl.filter(item => item.pid === "217").length === 1;
      }
    },
    methods: {
      numberTransform,
      priceTransform,
      nameTranslate,
      ...mapActions('cartContext', {
        setCartContext: CART_ACTIONS.SET_CART_CONTEXT,
      }),
      getDomainName(domain) {
        const index = this.summaryList.findIndex((el) => el.key === 'domain-name');
        if(index === -1) {
          this.summaryList.push(domain);
        } else {
          this.$set(this.summaryList, index, domain);
        }
      },
      getCycleData(item, field, freeSsl = false) {
        const itemProduct = freeSsl ? item?.productFreeSsl : item?.product;
        const filteredCycles = itemProduct?.billingcycles?.filter(billing => billing.currency_code === this.currency) || [{}];
        const period = this.paymentPeriod.name === item?.product.name ? this.paymentPeriod.period : filteredCycles[0]?.period;
        return filteredCycles?.find(billing => billing.period === period)?.[field];
      },
      presetPaymentPeriod(period) {
        const index = this.summaryList.findIndex((el) => el.key === 'payment-period');
        if(index === -1 ) {
          this.summaryList.unshift(period);
        } else {
          this.$set(this.summaryList, index, period);
        }

        this.$set(this.summaryList, index, period);
      },
      getPaymentPeriod(period) {
        this.paymentPeriod = period;
        this.paymentPeriod.name = this.selectedUpsell && this.selectedUpsell.product ? this.nameTranslate(this.selectedUpsell.product) : period.name;
        this.paymentPeriod.title = this.selectedUpsell && this.selectedUpsell.product ? this.nameTranslate(this.selectedUpsell.product.group) : period.title;
        this.paymentPeriod.type = this.selectedUpsell && this.selectedUpsell.product ? this.selectedUpsell.product.type : '';
        this.paymentPeriod.basePrice = this.isFreeSsl ? this.getCycleData(this.selectedUpsell, "price", true) : 0;
        this.savedPaymentPeriod = period;
        this.$store.commit(`cartContext/${CART_MUTATIONS.SET_CART_CONTEXT}`, { billingcycleUpsell: period.period });
        this.presetPaymentPeriod(period);
      },
      restorePaymentPeriod() {
        if (this.savedPaymentPeriod) {
          this.getPaymentPeriod(this.savedPaymentPeriod);
        }
      },
      async getAllSsl() {
        try {
          this.loading = true;
          this.savedAllSsl = await getAllUpsaleSsl();
          this.getFiltredSsl();
        } catch (error) {
          Sentry.captureException(error);
        } finally {
          this.loading = false;
        }
      },
      async openPopup() {
        if (!this.allSsl || this.allSsl.length === 0) {
          this.loadingAllSsl = true;
          await this.getAllSsl();
        }
        this.loadingAllSsl = false;
        this.showPopup = true;
      },

      updateUpsellData({key, data}) {
        this.upsellData = {
          ...this.upsellData,
          [key]: [data],
        };

        this.$set(this, 'selectedUpsell', {...data});

        this.$nextTick(() => {
          this.$emit('input', this.selectedUpsell);
        });
      },
      getHeaderText() {
        let text = this.state === 'popup-active' ? this.$t(`upsell.${this.flow}.heading.fromPopup`) : this.$t(`upsell.${this.flow}.heading.default`);
        if(this.flow === UPSELL_FLOW.SSL_HOSTING && this.isFreeSsl) {
          text = this.$t(`upsell.${this.flow}.heading.free`)
        }
        return text;
      },
      getFilteredDetails(fields) {
        return Object.keys(fields)
          .filter(key => SSL_POPUP.DETAILS.includes(key) && (key !== 'sealInSearch' || fields[key]))
          .reduce((obj, key) => {
            obj[key] = fields[key];
            return obj;
          }, {});
      },
      getSslContent(key, item) {
        switch (key) {
          case 'issuance':
          case 'validation':
            return this.$t(`popupSsl.details.${key}.${item}.dropdown`);
          case 'subdomainsProtection':
          case 'companyNameInSSLDetails':
          case 'mobileSupport':
          case 'sealInSearch':
            return item ? '+' : '&#8212;';
          default:
            return this.$t(`popupSsl.details.${key}.${item}`) || '&#8212;';
        }
      },
      addProductFreeSsl(item) {
        if (item.pid === this.freePid) {
          const product218 = this.savedAllSsl.find(i => i.pid === "218")?.product;
          return product218 ? { ...item, productFreeSsl: product218 } : item;
        }
        return item;
      },
      getSslHosting() {
        if (Array.isArray(this.upsellData.ssl) && this.upsellData.ssl.some(item => item.pid === "217")) {
          this.upsellData.ssl = this.upsellData.ssl.filter(item => item.pid === "217");
        }

        if (
          !this.selectedUpsell ||
          this.selectedUpsell?.length < 0 ||
          this.selectedUpsell.pid === this.freePid ||
          (this.state !== 'popup-active' && this.selectedUpsell)
        ) {
          if (this.flow === UPSELL_FLOW.SSL_HOSTING) {
            if (this.isFreeSslPeriod) {
              this.upsellData.ssl = this.initUpsellData.ssl
                .filter(item => item.pid === this.freePid)
                .map(this.addProductFreeSsl);
            } else {
              const cert = this.initUpsellData.ssl.find(item => item.pid === "217");
              this.upsellData.ssl = cert ? [this.addProductFreeSsl(cert)] : [];
            }

            setTimeout(() => {
              if (this.isFreeSslPeriod) {
                this.selectedUpsell = this.upsellData.ssl[0];
              } else if (this.selectedUpsell?.pid === this.freePid) {
                this.selectedUpsell = null;
              }
            }, 500);
          }
        }
      },
      getFiltredSsl() {
        this.allSsl = this.flow === UPSELL_FLOW.SSL_HOSTING && this.isFreeSslPeriod
          ? this.savedAllSsl.map(item => {
            const replacement = item.pid === "218"
              ? this.initUpsellData?.ssl?.find(i => i.pid === this.freePid)
              : null;

            return replacement ? this.addProductFreeSsl(replacement) : item;
          })
          : [...this.savedAllSsl];

      },
      getPaymentPeriods() {
        this.filteredPaymentPeriods = this.selectedUpsell?.product?.billingcycles?.filter(
          item => item.currency_code === this.currency
        )
      }
    },
    watch: {
      "selectedUpsell": {
        handler(newSelectedUpsell, oldSelectedUpsell) {
          const paymentPeriodKey = 'payment-period';
          if ((newSelectedUpsell && oldSelectedUpsell) && newSelectedUpsell !== oldSelectedUpsell) {
            this.savedPaymentPeriod = null;
          }
          if (newSelectedUpsell) { this.getPaymentPeriods(); }

          setTimeout(() => {
            if (!newSelectedUpsell) {
              const index = this.summaryList.findIndex(el => el.key === paymentPeriodKey);
              if (index !== -1) {
                this.summaryList.splice(index, 1);
              }
            } else {
              const index = this.summaryList.findIndex((el) => el.key === 'payment-period');
              if(index === -1 ) {
                this.getPaymentPeriod(this.paymentPeriod)
              }
            }

          }, 300)

          this.$store.commit(`cartContext/${CART_MUTATIONS.SET_CART_CONTEXT}`, { pidUpsell: Number(newSelectedUpsell?.pid || 0) });
        },
        deep: true,
      },
      currency() {
        this.getPaymentPeriods();
      },
      isVisiblePaymentPeriod(newValue) {
        if (newValue) {
          this.restorePaymentPeriod();
        }
      },
      summaryList(newList) {
        const listToEmit = Array.isArray(newList) && newList.length > 0
          ? newList.map(upsell => ({ ...upsell, key: `upsell-${upsell.key}`}))
          : this.summaryList;

        this.$emit('upsell', listToEmit);
      },
      "initUpsellData": {
        immediate: true,
        deep: true,
        handler(newVal) {
          if (!newVal) return;
          if (Array.isArray(newVal)) {
            this.upsellData = [...newVal];
          }
          else if (typeof newVal === 'object') {
            this.upsellData = { ...newVal };
          }
          else {
            this.upsellData = {};
          }

          this.getSslHosting();
        },
      },
      isFreeSslPeriod(val) {
        this.getSslHosting();
        this.getFiltredSsl();
      },
      'upsellData.ssl': {
        immediate: true,
        deep: true,
        handler(arr) {
          this.isFreeSsl = arr[0].pid === this.freePid;
        },
      },
      isVisibleSslHostingGift(val) {
        if(!val) { this.autoInstallSsl = false }
      },
      autoInstallSsl(val) {
        const product = this.cartContext?.products?.find(p => Number(p.pid) === Number(this.selectedUpsell?.pid));
        if (product) {
          product.auto_install_ssl_domain = this.autoInstallSsl ? this.domainName : undefined;
        }
      }
    }
  }
</script>

<style lang="scss">
  .upsell-block {
    color: $black;

    .v-expansion-panels {
      z-index: 0;
    }

    .v-expansion-panel {

      .block {
        padding: 0;
        background-color: transparent;
      }
    }

    .v-expansion-panel-header {
      flex-direction: column;
      position: relative;
      margin: 0 20px 0 0 !important;
      min-height: 0 !important;

      .cost {
        padding-bottom: 0;
        width: auto;

        .new {
          font-weight: 400;
        }
      }

      .head {
        padding-bottom: 0;

        &+.added {
          padding-top: 10px;
        }

        &+.switcher {
          padding-top: 12px;
        }
      }

      .v-input {

        .v-label {
          color: $gray-text;
        }
      }

      p {
        margin-bottom: 0;
        padding-top: 7px;
        font-size: 16px;

        &+.switcher {
          padding-top: 12px;
        }
      }
    }

    .v-expansion-panel-content {
      margin-top: 24px;

      .v-expansion-panel-content__wrap {
        padding-bottom: 0;
      }
    }

    .v-expansion-panel-header__icon {
      position: absolute;
      top: 0;
      right: 0;

      i {
        font-size: 24px;
        line-height: 1;
        color: $primary !important;
      }
    }

    h3.header {
      font-size: 21px;
      margin-bottom: 0;
      padding-right: 30px;
      width: 100%;

      +.head {
        margin-top: 17px;
      }
    }

    .free-promo {
      display: inline;
      background-color: $green;
      margin: 0 7px 0 0 ;
    }

    .cost {
      display: flex;
      width: 100%;
      align-items: baseline;
      padding-bottom: 16px;

      span:not(:last-child) {
        padding-right: 6px;
      }

      .old {
        text-decoration: line-through;
        color: $gray-text;
        font-size: 12px;
        padding-right: 12px !important;
      }

      .new {
        font-size: 19px;
        font-weight: 400;

        .price-transform {
          font-weight: 700;
        }
      }

      .period {
        font-size: 16px;
      }
    }

    .multiple {
      .head {
        flex-direction: column;
        align-items: flex-start;
      }
    }

    .head {
      padding-bottom: 11px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      row-gap: 4px;
      width: 100%;

      .group {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;

        +.group {
          padding-top: 8px;
        }
      }

      img {
        display: block;
        width: 103px;
        height: 15px;
        margin-right: 16px;
      }

      .heading {
        font-size: 19px;
        font-weight: 700;
        white-space: nowrap;
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;

        &:not(:last-child) {
          padding-right: 40px;
        }

        > i {
          color: $green;
          font-size: 17px;
          line-height: 1;
          margin-right: 3px;
        }

        .tooltip i {
          font-size: 17px;
        }

        .title {
          padding-right: 3px;
          font-weight: 400;
        }
      }

      .line {
        margin-left: auto;

        @media (max-width: $phablet) {
          order: -1;
          margin: 0 0 10px;
          width: 100%;
        }
      }

      .highlight {
        background-color: $green;
        margin: 0;
      }
    }

    .details {
      padding-bottom: 16px;
      font-size: 16px;

      .v-expansion-panel-header {
        flex-direction: row;
        align-items: center;
      }

      .v-expansion-panel-header__icon {
        position: relative;
        height: 22px;
        margin: 0;
        display: inline-block;

        .v-icon {
          font-size: inherit;
        }

        .v-icon__svg {
          height: 22px;
          width: 22px;
        }
      }

      .v-expansion-panel-content {
        margin-top: 7px;
      }
    }

    .bottom {
      margin-top: auto;
    }

    .certificates {
      margin: 0 -24px;
      padding: 20px 45px 24px 24px;
      border-top: 1px solid #FFF2C3;
      background: linear-gradient(90deg, rgba(255, 249, 157, 0.40) 0.04%, rgba(255, 249, 157, 0.15) 99.96%), #FFF;
      font-size: 16px;

      @media (max-width: $tablet) {
        margin-right: -19px;
        margin-left: -19px;
      }

      &:last-child,
      &:has(+ .hide-mb) {
        margin-bottom: -24px;
      }

      b {
        display: block;
        padding-bottom: 3px;
      }

      .button {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;

        :hover {
          cursor: pointer;
        }
      }

      i {
        padding-right: 4px;
        font-size: 14px;
      }

      .link {
        color: $black !important;
      }

      &.basic {
        padding: 0;
        margin: 0;
        border: none;
        background: transparent;

        b {
          display: none;
        }
      }
    }

    .added {
      color: $primary;
      font-size: 16px;
      display: flex;
      width: 100%;
      align-items: center;

      i {
        color: $primary;
        font-size: 11px;
        padding-right: 2px;
      }
    }

    .switcher {

      &.v-input--is-label-active {

        .v-label {
          color: $primary !important;
        }
      }

      .v-label {
        font-size: 16px;
      }

      .v-input--selection-controls__input {
        margin-right: 4px;
      }
    }

    .ssl-payment-periods {

      &:not(:last-child) {
        padding-bottom: 40px;
      }

      &:not(:first-child) {
        padding-top: 40px;
      }

      & + .domain-name-block {
        padding-top: 0 !important;
      }
    }

    .domain-name-block:not(:first-child) {
      padding-top: 40px;
    }

    .ssl-hosting-gift {
      font-size: 16px;
      color: $green;
      margin-bottom: 12px;

      i {
        font-size: 14px;
        color: $green;
        vertical-align: baseline;
      }
    }

    .auto-install-ssl {
      margin-top: -8px;
      margin-bottom: 24px;

      .v-label, p {
        font-size: 16px;
      }

      .v-input--selection-controls__input {
        height: 22px;
        width: 22px;
      }

      a {
        color: $base-anchor !important;

        &:after {
          background-color: $base-anchor;
        }
      }
    }
  }

  .ssl-block {
    padding-bottom: 24px;
    display: flex;
    flex-wrap: wrap;

    &.multiple {
      gap: 20px;

      .item {
        flex: 1 1 calc(50% - 20px);

        @media (max-width: $tablet) {
          flex: 1 1 100%;
        }
      }
    }

    .item {
      width: 100%;
      padding: 30px 20px 20px;
      border: 1px solid $gray-soft;
      background-color: $white;
      border-radius: 7px;
      transition: $transition;
      display: flex;
      flex-direction: column;

      &.is-active {
        background-color: $blue-active;
        border-color: $blue-active;
      }
    }

    p {
      font-size: 16px;
      margin-bottom: 16px;
    }
  }

  .v-tooltip__content > span {
    display: block;

    .detail-name:after {
      content: ': ';
      display: inline;
    }
  }

  .sslHosting, .sslDomain, .domainSsl {

    > .block {
      background: linear-gradient(358deg, #FFF 1.87%, rgba(255, 255, 255, 0.00) 97.81%), linear-gradient(270deg, rgba(255, 249, 157, 0.40) 0%, rgba(255, 249, 157, 0.00) 99.64%), #FFF;
    }

    &.isFreeSsl {

      .switcher {

        .v-label {
          color: $gray;
        }
      }
    }
  }
</style>
